import type { ComponentPropsWithoutRef } from "react";
import { CreditMark } from "@/components/icons/CreditMark";
import { cn } from "@/lib/utils";

type CreditAmountProps = ComponentPropsWithoutRef<"span"> & {
  amount: number | null | undefined;
  showLabel?: boolean;
};

/** Formats a credit balance with the visual marker used throughout the app. */
function CreditAmount({
  amount,
  className,
  showLabel = true,
  ...props
}: CreditAmountProps) {
  if (amount === null || amount === undefined) {
    return <span className={className}>Loading credits</span>;
  }

  const formattedAmount = amount.toLocaleString();

  return (
    <span
      aria-label={`${formattedAmount} ${amount === 1 ? "credit" : "credits"}`}
      className={cn("inline-flex items-center gap-1.5 tabular-nums", className)}
      {...props}
    >
      <CreditMark className="size-[1.05em] shrink-0" />
      <span>{formattedAmount}</span>
      {showLabel ? <span className="font-normal opacity-75">credits</span> : null}
    </span>
  );
}

export { CreditAmount };
